import React, { useState, useEffect } from 'react';

const CONSENT_STORAGE_KEY = 'auditmypay_consent_granted';

export function hasUserConsented(): boolean {
  return localStorage.getItem(CONSENT_STORAGE_KEY) === 'true';
}

export function setUserConsent(granted: boolean): void {
  if (granted) {
    localStorage.setItem(CONSENT_STORAGE_KEY, 'true');
  } else {
    localStorage.removeItem(CONSENT_STORAGE_KEY);
  }
}

interface ConsentGateProps {
  onConsent: () => void;
}

export function ConsentGate({ onConsent }: ConsentGateProps) {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (hasUserConsented()) {
      onConsent();
    }
  }, [onConsent]);

  const handleAccept = () => {
    setUserConsent(true);
    onConsent();
  };

  return (
    <section
      className="consent-gate"
      aria-labelledby="consent-heading"
      role="region"
    >
      <h2 id="consent-heading">Data Collection Consent</h2>
      <p>
        Before you can upload documents, we need your explicit consent for data
        collection and processing.
      </p>
      <p>
        By consenting, you agree that AuditMyPay may collect, process, and
        temporarily store the documents you upload for the purpose of auditing
        your pay. All data is encrypted, personally identifiable information is
        redacted, and documents are deleted by default after analysis unless you
        opt in to data retention.
      </p>

      <div className="consent-checkbox-wrapper">
        <label htmlFor="consent-checkbox" className="consent-label">
          <input
            type="checkbox"
            id="consent-checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            aria-describedby="consent-description"
          />
          <span id="consent-description">
            I consent to data collection and processing as described above
          </span>
        </label>
      </div>

      <button
        onClick={handleAccept}
        disabled={!checked}
        className="consent-accept-button"
        aria-label="Accept consent and continue to upload"
      >
        Accept and Continue
      </button>
    </section>
  );
}
